export default [
  {
    path: '/b/pendalaman-register',
    redirect: '/b/pendalaman-register',
    name: 'bPendalamanRegister',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bPendalamanRegisterIndex',
        component: () => import('@/views/b/pendalamanRegister/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-pendalaman-register',
          pageTitle: 'Pendalaman Register',
          breadcrumb: [
            {
              text: 'B',
            },
            {
              text: 'Pendalaman Register',
              active: true,
            },
          ],
        },
      },
      {
        path: '/b/pendalaman-register/input',
        name: 'bPendalamanRegisterTambah',
        component: () => import('@/views/b/pendalamanRegister/Tambah.vue'),
        meta: {
          action: 'Tambah',
          resource: 'b-pendalaman-register',
          pageTitle: 'Pendalaman Register',
          breadcrumb: [
            {
              text: 'B',
            },
            {
              text: 'Pendalaman Register',
            },
            {
              text: 'Input',
              active: true,
            },
          ],
        },
      },
      {
        path: '/b/pendalaman-register/update/:id',
        name: 'bPendalamanRegisterUpdate',
        component: () => import('@/views/b/pendalamanRegister/Update.vue'),
        meta: {
          action: 'Update',
          resource: 'b-pendalaman-register',
          pageTitle: 'Pendalaman Register',
          breadcrumb: [
            {
              text: 'B',
            },
            {
              text: 'Pendalaman Register',
            },
            {
              text: 'Update',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
